export default {
    color: '#ff9d72',
    urls: ['/upcoming-events', '/host-an-event', '/events']
}
